import { FieldType, TextStyle } from '@coast/schemas';
import { ReactElement } from 'react';
import { defaultFieldPresenter } from '@shared/components/blocks/lib/defaultFieldPresenter';
import { API } from '@shared/types/api';
import { assigneesToString } from './assigneesToString';

export function fieldPresenter(
  value: API.ShortUserFragment[],
  fieldType: FieldType,
  textStyle: TextStyle,
  textColor: string,
): ReactElement {
  return defaultFieldPresenter(assigneesToString(value), fieldType, textStyle, textColor);
}
